import angular from 'angular';

angular.module('AaApp.Opp').constant('pandoActionTypes', {
    tab:1,
    message: 2,
    process: 3

});
